import React from 'react';
import PropTypes from 'prop-types';
import checkGradeReleased from '$utils/checkGradesReleased';
import Pill from '$components/Pill';

const GradesReleased = ({ gradesReleasedAt }) => {
  const areGradesReleased = checkGradeReleased({ gradesReleasedAt });
  const text = areGradesReleased
    ? 'Grades released'
    : 'Grades not yet released';
  const look = areGradesReleased ? 'green' : 'purple';

  return (
    <Pill data-testid="grades-released-pill" look={look}>
      {text}
    </Pill>
  );
};

GradesReleased.propTypes = {
  gradesReleasedAt: PropTypes.string,
};

GradesReleased.defaultProps = {
  gradesReleasedAt: undefined,
};

export default GradesReleased;
